<template>
    <div class="app-dashboard">
        <!-- BEGIN: Subheader -->
        
        <!-- END: Subheader -->


        <div class="m-content">
            <!--Begin::Section-->
            <div class="m-grid__item m-grid__item--fluid m-wrapper">

            </div>
            <!--End::Section-->
        </div>
    </div>
</template>


<script>

export default {
    name: "app-dashboard",
    data() {
        return {

        };
    },
};
</script>


<style lang="scss">
</style>
